import { useState } from 'preact/hooks';
import { register } from '@/api';
import { digitsOnly, formatPhone } from '@/utils/phone';
import { notify } from '@/store/ui';
import css from './AuthScreen.module.css';

export function RegisterForm({ onShowLogin }) {
  const [form, setForm] = useState({
    company_name: '',
    inn: '',
    phone: '',
    email: '',
    password: '',
    password2: '',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  function set(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  function validate() {
    if (!form.company_name.trim() || form.company_name.trim().length < 2) {
      return 'Введите название организации';
    }
    if (!/^\d{10}$|^\d{12}$/.test(form.inn)) {
      return 'ИНН должен содержать 10 или 12 цифр';
    }
    if (form.phone.replace(/\D/g, '').length < 11) {
      return 'Введите корректный номер телефона';
    }
    if (form.password !== form.password2) {
      return 'Пароли не совпадают';
    }
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validate();
    if (v) {
      setError(v);
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      const result = await register({
        company_name: form.company_name.trim(),
        inn: form.inn.trim(),
        phone: form.phone.trim(),
        email: form.email,
        password: form.password,
      });
      notify(
        result.is_existing_partner
          ? `Вы привязаны к компании «${result.partner_name}». Теперь можно войти.`
          : 'Регистрация успешна! Можете войти.',
      );
      onShowLogin();
    } catch (err) {
      setError(err.message || 'Ошибка регистрации');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form class={css.form} onSubmit={handleSubmit} noValidate>
      <h2 class={css.title}>Регистрация</h2>
      <div class={css.field}>
        <label>Название организации *</label>
        <input
          type="text"
          required
          placeholder="ООО «Ваша организация»"
          value={form.company_name}
          onInput={(e) => set('company_name', e.target.value)}
        />
      </div>
      <div class={css.field}>
        <label>ИНН *</label>
        <input
          type="text"
          required
          placeholder="10 или 12 цифр"
          maxLength={12}
          value={form.inn}
          onInput={(e) => set('inn', digitsOnly(e.target.value, 12))}
        />
      </div>
      <div class={css.field}>
        <label>Телефон *</label>
        <input
          type="tel"
          required
          placeholder="+7 (___) ___-__-__"
          value={form.phone}
          onInput={(e) => set('phone', formatPhone(e.target.value))}
        />
      </div>
      <div class={css.field}>
        <label>E-mail *</label>
        <input
          type="email"
          required
          placeholder="email@company.ru"
          value={form.email}
          onInput={(e) => set('email', e.target.value)}
        />
      </div>
      <div class={css.field}>
        <label>Пароль *</label>
        <input
          type="password"
          required
          minLength={6}
          placeholder="Минимум 6 символов"
          value={form.password}
          onInput={(e) => set('password', e.target.value)}
        />
      </div>
      <div class={css.field}>
        <label>Повторите пароль *</label>
        <input
          type="password"
          required
          placeholder="Повторите пароль"
          value={form.password2}
          onInput={(e) => set('password2', e.target.value)}
        />
      </div>
      {error && (
        <div class={css.error} role="alert">
          {error}
        </div>
      )}
      <button class={css.submit} type="submit" disabled={submitting}>
        {submitting ? 'Регистрируем…' : 'Зарегистрироваться'}
      </button>
      <div class={css.links}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onShowLogin();
          }}
        >
          Уже есть аккаунт? Войти
        </a>
      </div>
    </form>
  );
}
